import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Backdrop from '@mui/material/Backdrop';
import i18next from 'i18next';

import icRotation from '~assets/ic_rotate.png';
import icMercatTitle from '~assets/ic_mercat_title.png';
import icIsoType from '~assets/mercat.svg';

import { getIsPortrait } from './utils';
import styles from './styles.module.scss';

function OrientationOverlay() {
  const [isPortrait, setIsPortrait] = useState(getIsPortrait());

  const updateOrientation = () => {
    setIsPortrait(getIsPortrait());
  };

  useEffect(() => {
    window.addEventListener('orientationchange', updateOrientation);
    return () => {
      window.removeEventListener('orientationchange', updateOrientation);
    };
  }, []);

  return (
    <Backdrop
      open={isPortrait}
      sx={{
        zIndex: ({ zIndex }) => zIndex.drawer + 1
      }}>
      <Stack display="flex" direction="column" className={styles.containerBackdrop}>
        <Stack direction="row" spacing={1} justifyContent="center">
          <img src={icIsoType} />
          <img src={icMercatTitle} className={styles.mercatTitle} />
        </Stack>
        <Stack flex={1} direction="column" justifyContent="center" alignItems="center" spacing={1}>
          <img src={icRotation} className={styles.rotateIcon} />
          <Typography textAlign="center" fontSize={24} fontWeight="fontWeightBold">
            {i18next.t('orientation:message')}
          </Typography>
        </Stack>
      </Stack>
    </Backdrop>
  );
}

export default OrientationOverlay;
